import React, {useEffect, useState} from "react";
import "./UserInitialsComponent.scss"
export default function UserInitialsComponent(props: UserInitialsComponentProps) {
    const [initials, setInitials] = useState<string>("");
    const {size = "size32", ...other} = props;
    useEffect(() => {
        let firstName = props.firstName;
        let lastName = props.lastName;
        if (props.fullName){
            const split = props.fullName.split(" ");
            if (split.length > 0)
                firstName = split[0];
            if (split.length> 1)
                lastName = split[1];
        }
        let i = ((firstName ? firstName.charAt(0) : '') + (lastName ? lastName.charAt(0) : '')).toUpperCase();
        setInitials(i);
    }, [props.firstName, props.lastName, props.fullName]);

    return (
        <div className={`user-icon ${size}`}>{initials}</div>
    )
}

export interface UserInitialsComponentProps {
    firstName?: string;
    lastName?: string;
    // (optional)
    fullName?: string;
    size?: "size32" | "size100";
}
